<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-banner_box" :style="banner_box_Style">
      <div class="dft-banner_bg" :style="banner_bg_style">
        <div class="dft-banner_bg1" :style="banner_bg1_style">
        </div>
        <div class="dft-banner_bg2" :style="banner_bg2_style">
        </div>
      </div>
      <div class="dft-banner_info_box" :style="banner_info_style">
        <div class="dft-banner_area" :style="banner_area_style">
          <div class="dft-banner_logo" :style="banner_logo_style">
            <!-- uniapp -->
            <el-image class="img_class" :src="dft_banner_bg" :fit="fit"></el-image>
          </div>
          <div class="dft-banner_iarea" :style="banner_iarea_style">
            <div class="dft-banner_name" :style="[banner_name_style,name_style]">{{ '用户昵称' }}</div>
            <div class="dft-banner_cnt" v-if="styleClass != '5'" :style="[banner_cnt_style,cnt_style]">
              <div class="dft-banner_event">{{ '登录手机号' }}</div>
            </div>
          </div>
          <!-- <div class="dft-banner_btn" :style="banner_btn_style">{{ '设置' }}</div> -->
        </div>
      </div>
      <div class="dft_vip_box dft_vip_box1" v-if="showvip && viptype == '1'">
        <div class="dft_vip_icon">
          <el-image class="img_class" :src="vipicon" :fit="fit"></el-image>
        </div>
        <div class="dft_vip_info">
          <div>VIP尊贵会员</div>
          <div style="font-size: 12px">会员好礼享不停 VIP四大权益</div>
        </div>
        <div class="dft_vip_arrow">
          <div>立即开通</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="dft_vip_box2" v-else-if="showvip && viptype == '2'">
        <div class="vip_info_box">
          <div class="dft_vip_icon">
            <el-image class="img_class" :src="vipicon" :fit="fit"></el-image>
          </div>
          <div class="dft_vip_info">VIP</div>
        </div>
        <div class="dft_vip_arrow">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="dft_vip_box dft_vip_box3" v-else-if="showvip && viptype == '3'">
        <div class="dft_vip_icon">
          <el-image class="img_class" :src="vipicon" :fit="fit"></el-image>
        </div>
        <div class="dft_vip_info">
          <div class="dft_vip_text1">VIP尊贵会员</div>
          <div class="dft_vip_text2">会员好礼享不停 VIP四大权益</div>
        </div>
        <div class="dft_vip_arrow">
          <div>立即开通</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: [Array, Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      dft_banner_bg: require('@/assets/images/useravatar.png'),
      vipicon: 'https://stjnfile.duochicai.com/resources/upload/dcc/member.png',//require('@/assets/images/vipicon.png'),
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 数据
    bannerImg () {
      return {
        'background-image': this.compData?.attr?.a1.value || this.dft_banner_bg
      }
    },
    styleClass () {
      return this.compData?.attr?.a2.value
    },
    logobg () {
      return this.compData?.attr?.a3.value == '1'
    },
    showvip () {
      return this.compData?.attr?.a4.value == '1'
    },
    viptype () {
      return this.compData?.attr?.a5.value
    },
    fit () {
      return 'contain' // ? 'aspectFit' : 'widthFix'
    },
    // 样式
    container_Style () {
      switch (this.styleClass) {
        case '1':
        case '3':
          return {
            'height': `${165}px`,
            'margin-bottom': this.showvip && this.viptype == '3'?`${45}px`:'0',
          }
        case '2':
          return {
            'height': `${218}px`,
            'margin-bottom': this.showvip && this.viptype == '3'?`${45}px`:'0',
          }
        case '4':
          return {
            'height': `${238}px`,
            'margin-bottom': this.showvip && this.viptype == '3'?`${45}px`:'0',
          }
        case '5':
          return {
            'height': `${165}px`,
            'margin-bottom': this.showvip && this.viptype == '3'?`${45}px`:'0',
          }
        default:
          return {
          }
      }
    },
    banner_box_Style () {
      return {
        // [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value == '1' ? '': `${this.compData?.attr?.a5.value / 2}px`,
        // 'justify-content': this.compData?.attr?.['a4']?.value == 'left'?'flex-start':'center',
        // [this.compData?.attr?.['a8']?.key]: this.compData?.attr?.['a8']?.value,
        // [this.compData?.attr?.['a9']?.key]: this.compData?.attr?.['a9']?.value,
      }
    },
    banner_bg_style () {
      switch (this.styleClass) {
        case '2':
          return {
            'height': `${165}px`
          }
        case '4':
          return {
            'height': `${130}px`
          }
        default:
          return {
          }
      }
    },
    banner_bg1_style () {
      return {
        // 'padding-right': this.scan?'60px':'0',
        'background-image': `url(${this.compData?.attr?.a1.value || this.dft_banner_bg})`
      }
    },
    banner_bg2_style () {
      switch (this.styleClass) {
        case '2':
        case '3':
        case '4':
          return {
            'background-color': 'initial',
            'background-image': 'linear-gradient(0deg, #000, transparent)'
          }
        default:
          return {}
      }
    },
    banner_info_style () {
      switch (this.styleClass) {
        case '2':
          return {
            'top': `${130}px`
          }
        case '5':
          return {
            'top': `${30}px`
          }
        default:
          return {
          }
      }
    },
    banner_area_style () {
      switch (this.styleClass) {
        case '4':
        case '5':
          return {
            'height': `auto`,
            'flex-direction': `column`,
            'align-items': `center`
          }
        default:
          return {
          }
      }
    },
    banner_logo_style () {
      switch (this.styleClass) {
        case '2':
        case '4':
          return {
            'width': `${70}px`,
            'height': `${70}px`,
            'border-radius': `50%`,
            'background-color': this.logobg ? '#fff' : 'unset',
            'border': this.logobg ? '1px solid #fff' : 'unset'
          }
        case '5':
          return {
            'border-radius': `50%`,
            'background-color': this.logobg ? '#fff' : 'unset',
            'border': this.logobg ? '1px solid #fff' : 'unset'
          }
        default:
          return {
          }
      }
    },
    banner_iarea_style () {
      switch (this.styleClass) {
        case '4':
        case '5':
          return {
            'padding': `0`,
            'text-align': `center`
          }
        default:
          return {
          }
      }
    },
    banner_name_style () {
      switch (this.styleClass) {
        case '4':
          return {
            'display': 'inline-block',
            'max-width': '100%',
            'margin-top': '20px',
            'color': '#333',
            'text-shadow': 'none'
          }
        case '5':
          return {
            'display': 'inline-block',
            'max-width': '100%',
            'margin-top': '4px',
            'color': '#fff',
            'text-shadow': 'none',
            'padding-bottom': '2px',
            'border-bottom': '1px solid #ffffff80'
          }
        default:
          return {
          }
      }
    },
    banner_cnt_style () {
      switch (this.styleClass) {
        case '2':
        case '4':
          return {
            'color': `#989898`
          }
        default:
          return {
          }
      }
    },
    name_style () {
      return {
        'color': `${this.compData?.attr?.['a1nc'].value}`
      }
    },
    cnt_style () {
      return {
        'color': `${this.compData?.attr?.['a1cc'].value}`
      }
    },
    banner_btn_style(){
      switch (this.viptype) {
        case '2':
          return {
            'bottom': `60px`
          }
        default:
          return {
          }
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 0;
  background-color: #fff;
}
.dft-banner_box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: 14px;
  position: relative;
}
.dft-banner_bg{
  width: 100%;
  height: 100%;
  position: relative;
  .dft-banner_bg1{
    width: 100%;
    height: 100%;
    // background-image
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    overflow: hidden;
  }
  .dft-banner_bg2{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
  }
}
.dft-banner_info_box{
  position: absolute;
  width: 100%;
  top: 40px;
  // background: #fd2e08;
  // color: #fff;
  // width: 60px;
  // height: calc(100% - 6px);
  // margin: 0 3px;
  // padding: 4px 6px;
  // box-sizing: border-box;
  // text-align: center;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  .dft-banner_area{
    position: relative;
    width: 100%;
    height: 100%;
    height: 60px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
  }
}
.dft-banner_logo{
  width: 60px;
  height: 60px;
  overflow: hidden;
  vertical-align: bottom;
  background: #fff;
}
.dft-banner_iarea{
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  padding-left: 10px;
  box-sizing: border-box;
}
.dft-banner_cnt{
  margin-top: 12px;
}
.dft-banner_btn{
  position: absolute;
  bottom: 10px;
  right: 16px;
  color: #fff;
}
.dft-banner_name{
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-shadow: 0 1px 15px rgba(0, 0, 0, .5);
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
.dft_vip_box{
  .dft_vip_icon{
    margin-left: 8px;
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  .dft_vip_info{
    flex: 1;
    padding-left: 10px;
    padding-right: 10px;
  }
  .dft_vip_arrow{
    width: 40px;
  }
}
.dft_vip_box1{
  position: absolute;
  width: calc(100% - 40px);
  margin: 0 20px;
  bottom: 0;
  left: 0;
  height: 50px;
  background: linear-gradient(97deg, #4c5066 8.53%, #1d202f 94.35%);
  border-radius: 8px 8px 0 0;
  color: #f3ddc7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dft_vip_info{
    display: flex;
    flex-direction: column;
  }
  .dft_vip_arrow{
    width: 80px;
    box-sizing: border-box;
    padding: 4px 6px;
    margin-bottom: 4px;
    border-radius: 20px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #FFA446 0%, #F26C00 100%);
    color: #fff;
  }
}
.dft_vip_box2{
  background-image: linear-gradient(147deg, #414653, #373b44 74%);
  border-radius: 4px;
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, .2);
  color: #e3c86f;
  height: 99px;
  overflow: hidden;
  position: absolute;
  right: -50px;
  bottom: -5px;
  transform-origin: left;
  width: 179px;
  transform: rotate(15deg);
  .vip_info_box{
    flex: 1;
    display: flex;
    .dft_vip_icon{
      margin-left: 8px;
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
    .dft_vip_info{
      flex: 1;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .dft_vip_arrow{
    background-image: linear-gradient(134deg, #4d525e, #343841 79%);
    height: 74px;
    margin: 0 .5px .5px;
    padding: 5px 0 0 9px;
    // margin-left: 10px;
    // margin-top: 4px;
    // padding: 0 4px;
    // width: 24px;
    // height: 15px;
    // font-size: 13px;
    // border-radius: 8px;
    // border: 1px solid #e3c86f;
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
  }
}
.dft_vip_box3{
  bottom: -35px;
  display: flex;
  left: 0;
  margin: 0 16px;
  padding: 0 16px;
  position: absolute;
  right: 0;
  align-items: center;
  -webkit-box-pack: justify;
  // background: linear-gradient(90deg, #fff5ea -1.66%, #ffe8d1);
  background: linear-gradient(90deg, #FFD283 0%, #FBB44C 100%);
  border-radius: 8px;
  height: 70px;
  justify-content: space-between;
  .dft_vip_icon{
    width: 42px;
    height: 42px;
    margin-left: -8px;
  }
  .dft_vip_info{
    display: flex;
    flex-direction: column;
    .dft_vip_text1{
      color: #4F2A03;
      font-weight: 700;
      margin-bottom: 6px;
    }
    .dft_vip_text2{
      color: #603C06;
      font-size: 12px;
    }
  }
  .dft_vip_arrow{
    width: 80px;
    box-sizing: border-box;
    padding: 4px 6px;
    margin-bottom: 4px;
    border-radius: 20px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #FFA446 0%, #F26C00 100%);
    color: #fff;
  }
}
</style>
